module.exports = __webpack_public_path__ + "img/laptop.b532917.webp";